/*
 * @Description: Head框架传值BUS
 * @Author: wanqian
 * @Date: 2021-08-19 09:28:13
 * @LastEditTime: 2021-08-19 09:30:44
 */
import Vue from 'vue'
export default new Vue;


// WEBPACK FOOTER //
// ./src/components/pageframe/components/HeadBus.js